// localstorage key for qg id (third party id)
const QG_ID_KEY_LOCALSTORAGE = 'userId';

// localstorage key for wUserId (first party id)
const WUSER_ID_KEY_LOCALSTORAGE = 'wUserId';

/**
 * Retrieves the session ID from localStorage
 * The session ID is determined by the following order of priority:
 * 1. The third-party ID (`userId`), if available.
 * 2. The first-party ID (`wUserId`), if the third-party ID is not available.
 * 3. Returns `null` if neither ID is found in local storage.
 * @returns {string|null} The session ID if found, null otherwise
 */
function getSessionId(): string | null {
  const thirdPartyId = localStorage
    .getItem(QG_ID_KEY_LOCALSTORAGE)
    ?.replace(/"/g, '');

  const firstPartyId = localStorage.getItem(WUSER_ID_KEY_LOCALSTORAGE);

  return thirdPartyId || firstPartyId || null;
}
export default getSessionId;
